import React, { useContext, useState, useEffect } from "react";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { FiX, FiTool, FiHome, FiChevronDown, FiMapPin, FiNavigation, FiGrid } from "react-icons/fi";
import { LanguageContext } from "../../context/LanguageContext";
import LanguageSwitcher from "./LanuageSwitcher";
import ModelsDropdown from "./ModelsDropdown";

const Navbar = ({ customColor }) => {
  const { texts } = useContext(LanguageContext);
  const [showModels, setShowModels] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const [accordionOpen, setAccordionOpen] = useState({
    service: false,
    showroom: false,
    free: false,
    dream: false,
    taishan: false,
  });

  const toggleAccordion = (key) => {
    setAccordionOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const closeMobile = () => setMobileOpen(false);

  useEffect(() => {
    setMobileOpen(false);
    document.body.style.overflow = "auto";
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
  }, [mobileOpen]);

  return (
    <>
      {/* DESKTOP NAV */}
      <div className={`voyah-nav ${customColor ? "nav-custom" : ""}`}>
        <Link to="/" className="nav-logo-wrapper">
          <div className="nav-logo"></div>
        </Link>

        <div className="voyah-nav-links">
          <div
            className="models-hover-zone"
            onMouseEnter={() => setShowModels(true)}
          >
            <Link to="/models">
              {texts.navbar.models} <FiChevronDown size={28} />
            </Link>
          </div>

          {showModels && <ModelsDropdown onClose={() => setShowModels(false)} />}

          <div className="service-hover-zone">
            <Link to="/serviceSupport">
              {texts.navbar.service} <FiChevronDown size={28} />
            </Link>

            <div className="service-dropdown">
              <Link to="/warranty">{texts.warranty?.pageTitle || "Warranty"}</Link>
              <Link to="/road-assistance">
                {texts.roadAssistance?.pageTitle || "Road Assistance"}
              </Link>
            </div>
          </div>

          <div className="showroom-hover-zone">
            <Link to="/showroom-erbil">
              {texts.navbar.showroom} <FiChevronDown size={28} />
            </Link>

            <div className="showroom-dropdown">
              <Link to="/showroom-erbil">Erbil</Link>
              <Link to="/showroom-baghdad">Baghdad</Link>
            </div>
          </div>
        </div>

        <div className="voyah-nav-buttons">
          <button>
            <Link to="/testdrive">{texts.navbar.bookTestDrive}</Link>
          </button>
          <LanguageSwitcher />
        </div>

        <div className="hamburger" onClick={() => setMobileOpen(true)}>
          <RxHamburgerMenu size={35} />
        </div>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`mobile-menu-wrapper ${mobileOpen ? "open" : ""}`}
        onClick={closeMobile}
      >
        <div
          className="mobile-menu"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mobile-header">
            <Link to="/" onClick={closeMobile}>
              <div className="mobile-logo"></div>
            </Link>
            <button
              type="button"
              className="close-btn"
              aria-label="Close menu"
              onClick={closeMobile}
            >
              <FiX size={28} />
            </button>
          </div>

          <div className="mobile-body">
            <nav className="mobile-nav-list">
              <Link to="/" className="mobile-icon-row" onClick={closeMobile}>
                <span className="mobile-row-icon"><FiHome size={20} /></span>
                <span>Home</span>
              </Link>

              <button
                type="button"
                className="mobile-icon-row mobile-icon-accordion-trigger"
                onClick={() => toggleAccordion("service")}
              >
                <span className="mobile-row-icon"><FiTool size={20} /></span>
                <span>{texts.navbar.service}</span>
                <FiChevronDown
                  className={`accordion-arrow ${accordionOpen.service ? "open" : ""}`}
                  size={18}
                />
              </button>
              <div
                className={`accordion-content ${
                  accordionOpen.service ? "show" : ""
                }`}
              >
                <Link to="/warranty" onClick={closeMobile}>
                  {texts.warranty?.pageTitle || "Warranty"}
                </Link>
                <Link to="/road-assistance" onClick={closeMobile}>
                  {texts.roadAssistance?.pageTitle || "Road Assistance"}
                </Link>
              </div>

              <button
                type="button"
                className="mobile-icon-row mobile-icon-accordion-trigger"
                onClick={() => toggleAccordion("showroom")}
              >
                <span className="mobile-row-icon"><FiMapPin size={20} /></span>
                <span>{texts.navbar.showroom}</span>
                <FiChevronDown
                  className={`accordion-arrow ${accordionOpen.showroom ? "open" : ""}`}
                  size={18}
                />
              </button>
              <div
                className={`accordion-content ${
                  accordionOpen.showroom ? "show" : ""
                }`}
              >
                <Link to="/showroom-erbil" onClick={closeMobile}>
                  Erbil
                </Link>
                <Link to="/showroom-baghdad" onClick={closeMobile}>
                  Baghdad
                </Link>
              </div>

              <Link
                to="/testdrive"
                className="mobile-icon-row"
                onClick={closeMobile}
              >
                <span className="mobile-row-icon"><FiNavigation size={20} /></span>
                <span>{texts.navbar.bookTestDrive}</span>
              </Link>

              <Link
                to="/models"
                className="mobile-icon-row"
                onClick={closeMobile}
              >
                <span className="mobile-row-icon"><FiGrid size={20} /></span>
                <span>{texts.navbar.models}</span>
              </Link>

              <button
                type="button"
                className="mobile-icon-row mobile-icon-accordion-trigger"
                onClick={() => toggleAccordion("free")}
              >
                <span className="mobile-row-icon mobile-row-icon--spacer" />
                <span>{texts.navbar.voyahFree}</span>
                <FiChevronDown
                  className={`accordion-arrow ${accordionOpen.free ? "open" : ""}`}
                  size={18}
                />
              </button>
              <div
                className={`accordion-content ${accordionOpen.free ? "show" : ""}`}
              >
                <Link to="/voyah-free" onClick={closeMobile}>
                  {texts.navbar.findOutMore}
                </Link>
                <Link to="/voyah-free-build" onClick={closeMobile}>
                  {texts.navbar.buildYourCar}
                </Link>
                <Link to="/voyah-free-specifications" onClick={closeMobile}>
                  Specifications
                </Link>
              </div>

              <button
                type="button"
                className="mobile-icon-row mobile-icon-accordion-trigger"
                onClick={() => toggleAccordion("dream")}
              >
                <span className="mobile-row-icon mobile-row-icon--spacer" />
                <span>{texts.navbar.voyahDream}</span>
                <FiChevronDown
                  className={`accordion-arrow ${accordionOpen.dream ? "open" : ""}`}
                  size={18}
                />
              </button>
              <div
                className={`accordion-content ${accordionOpen.dream ? "show" : ""}`}
              >
                <Link to="/voyah-dream" onClick={closeMobile}>
                  {texts.navbar.findOutMore}
                </Link>
                <Link to="/voyah-dream-build" onClick={closeMobile}>
                  {texts.navbar.buildYourCar}
                </Link>
                <Link to="/voyah-dream-specifications" onClick={closeMobile}>
                  Specifications
                </Link>
              </div>

              <button
                type="button"
                className="mobile-icon-row mobile-icon-accordion-trigger"
                onClick={() => toggleAccordion("taishan")}
              >
                <span className="mobile-row-icon mobile-row-icon--spacer" />
                <span>{texts.navbar.voyahTaishan}</span>
                <FiChevronDown
                  className={`accordion-arrow ${accordionOpen.taishan ? "open" : ""}`}
                  size={18}
                />
              </button>
              <div
                className={`accordion-content ${
                  accordionOpen.taishan ? "show" : ""
                }`}
              >
                <Link to="/voyah-taishan" onClick={closeMobile}>
                  {texts.navbar.findOutMore}
                </Link>
                <Link to="/voyah-taishan-build" onClick={closeMobile}>
                  {texts.navbar.buildYourCar}
                </Link>
              </div>
            </nav>

            <div className="mobile-lang">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
